'use strict';

var button = require('../../../../../../../../../../_virtual/button.cjs');

(function (exports) {

	exports.ButtonAviaryIntentions = void 0;
	(function(ButtonAviaryIntentions) {
	    ButtonAviaryIntentions["danger"] = "danger";
	    ButtonAviaryIntentions["inverted"] = "inverted";
	})(exports.ButtonAviaryIntentions || (exports.ButtonAviaryIntentions = {}));
	
} (button.__exports));
//# sourceMappingURL=button.cjs.map
